export default __webpack_public_path__ + "static/media/chip.58cbed1c.wav";